<template>
  <div class="modal_edit_details">
    <div class="modal_edit_details__header">
      <h4 class="title">
        {{ translate('invoice.invoicing') }}
      </h4>
    </div>

    <div class="modal_edit_details__body">
      <div class="edit_block">

        <div class="line">
          <div class="form_select">
            <fg-input
                v-model="comment"
                type="text"
                :label="translate('invoice.comment')"
                :placeholder="translate('invoice.comment')"
            />
          </div>

        </div>
      </div>
    </div>
    <div class="modal_edit_details__footer">
      <span
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="save"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'IssueAnInvoice',
  data () {
    return {
      comment: ""
    }
  },
  methods: {
    save(){
      this.$emit("update", {comment: this.comment})
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_edit_details{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      .edit_block{
        width: 100%;
        height: 100%;
        .line{
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          .form_select{
            flex: 1;
            margin: 5px;
          }
        }
      }
    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
</style>
